import { useState } from 'react';
import { Building2, MapPin, ChevronDown, ChevronUp } from 'lucide-react';

interface ProjectDeveloperInfoProps {
  developer: any;
  getName: (val: any) => string;
}

export function ProjectDeveloperInfo({ developer, getName }: ProjectDeveloperInfoProps) {
  const [expanded, setExpanded] = useState(false);
  const desc = getName(developer.description);

  return (
    <section className="max-w-full overflow-hidden">
      <h2 className="font-display text-lg md:text-xl font-bold mb-3 md:mb-4">Developed By</h2>
      <div className="border rounded-xl p-4 md:p-5 flex items-start gap-3 md:gap-4">
        <div className="h-16 w-16 md:h-20 md:w-20 rounded-xl bg-muted flex items-center justify-center shrink-0 overflow-hidden border">
          {developer.logo_url ? (
            <img src={developer.logo_url} alt={developer.company_name} className="h-full w-full object-cover" />
          ) : (
            <Building2 className="h-8 w-8 text-muted-foreground" />
          )}
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="font-bold text-base md:text-lg break-words">{developer.company_name}</h3>
          {developer.city && (
            <div className="text-sm text-muted-foreground flex items-center gap-1 mt-0.5">
              <MapPin className="h-3.5 w-3.5 shrink-0" /> <span className="break-words">{developer.city}</span>
            </div>
          )}
          {developer.established_year && (
            <div className="text-xs text-muted-foreground mt-1">Established {developer.established_year}</div>
          )}
          {desc && (
            <>
              <p className={`text-sm text-muted-foreground mt-3 break-words ${expanded ? '' : 'line-clamp-2'}`}>{desc}</p>
              <button
                onClick={() => setExpanded(!expanded)}
                className="text-primary text-xs font-medium flex items-center gap-1 mt-1 hover:underline"
              >
                {expanded ? 'Show less' : 'Show more'}
                {expanded ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
